import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-change-order',
  templateUrl: './change-order.component.html',
  styleUrls: ['./change-order.component.scss']
})
export class ChangeOrderComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
